import { Model } from 'vue-api-query'
import api from '@/api'

/* Inject global axios instance as http client to Model */
Model.$http = api
